/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class AccountingActionKey {
  // static readonly CREATE_PDF_OFFER = 'accounting/action/create-pdf-offer';
  static readonly CREATE_PDF = 'accounting/action/create-pdf';
  static readonly COPY_DOCUMENT = 'accounting/action/copy-document';
  static readonly MOVE_DOCUMENT_FORWARD = 'accounting/action/move-document-forward';
  static readonly MOVE_DOCUMENT_BACKWARD = 'accounting/action/move-document-backward';
}
